import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
// 屏蔽ResizeObserver相关错误
import ResizeObserver from 'resize-observer-polyfill'
window.ResizeObserver = ResizeObserver
window.addEventListener('error', e => {
    if (e.message.includes('ResizeObserver')) {
        e.stopImmediatePropagation()
    }
})
createApp(App).use(store).use(router).use(ElementPlus,{locale: zhCn}).mount('#app')
